import { useState } from "react";
import { Col } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import { JobFilter } from "../../../../../Constants/Constants";
import CommonAccordionCard from "./CommonAccordionCard";
import { CommonAccordionCardData } from "../../../../../Data/Miscellaneous/JobSearch";

const LeftSidebar = () => {
  const [open, setOpen] = useState(false);
  return (
    <Col xl="3" className="xl-40 box-col-12">
      <div className="md-sidebar">
        <Btn color="primary" className="email-aside-toggle md-sidebar-toggle" onClick={() => setOpen(!open)}>
          {JobFilter}
        </Btn>
        <div className={`md-sidebar-aside job-sidebar custom-scrollbar ${open ? "open" : ""}`}>
          <div className="default-according style-1 faq-accordion job-accordion">
            {CommonAccordionCardData.map((items) => (
              <div className="accordion" key={items.id}>
                <CommonAccordionCard items={items} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Col>
  );
};
export default LeftSidebar;
